<template>
  <div class="l-anim">
    <lottie
      :options="defaultOptions"
      :height="400"
      :width="400"
      v-on:animCreated="handleAnimation"
    />
  </div>
</template>

<script>
import Lottie from 'vue-lottie';
import * as animationData from '../../assets/animations/data.json';

export default {
  name: 'TutorialAnimation',
  components: {
    lottie: Lottie,
  },
  data() {
    return {
      defaultOptions: { animationData: animationData.default },
      animationSpeed: 1,
    };
  },
  methods: {
    handleAnimation(anim) {
      this.anim = anim;
      this.anim.setSpeed(0.5);
    },
  },
};
</script>

<style lang="scss" scoped>
.c-options {
  position: absolute;
  top: 1rem;
  right: 1rem;
}
</style>
